import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { 'Content-Type': 'application/json' },
});

// Attach token: admin token takes precedence (admin dashboard), else customer token (storefront)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('byanfal_admin_token') || localStorage.getItem('byanfal_customer_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const setAdminToken = (token) => {
    if (token) localStorage.setItem('byanfal_admin_token', token);
    else localStorage.removeItem('byanfal_admin_token');
};

export const getAdminToken = () => localStorage.getItem('byanfal_admin_token');

export const setCustomerToken = (token) => {
    if (token) localStorage.setItem('byanfal_customer_token', token);
    else localStorage.removeItem('byanfal_customer_token');
};

export const getCustomerToken = () => localStorage.getItem('byanfal_customer_token');
